import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TicketDifficultyLevel } from "@bonliva-crm/shared";

const useStyles = makeStyles(() => ({
  infoBox: {
    // backgroundColor: "#f6f3f0",
    color: "#6b777d",
    maxWidth: 560,
    // padding: "16px 20px",
    borderRadius: 10,
    // boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    lineHeight: 1.4,
    fontSize: "0.8rem",
    boxSizing: "border-box"
  },

  innerBoxes: {
    display: "flex",
    flexDirection: "column",
    gap: 10
  },

  innerBox: {
    backgroundColor: "#fff",
    borderRadius: 4,
    padding: "12px 14px",
    borderLeft: "3px solid"
  },

  green: {
    borderLeftColor: "#4ade80"
  },

  yellow: {
    borderLeftColor: "#facc15"
  },

  red: {
    borderLeftColor: "#f87171"
  },

  tip: {
    borderLeftColor: "#6b777d"
  },

  boxTitle: {
    fontWeight: 700,
    fontSize: "0.9rem",
    marginBottom: 6,
    display: "flex",
    alignItems: "center",
    gap: 5
  },

  boxDescription: {
    fontSize: "0.8rem",
    marginBottom: 6,
    fontStyle: "italic"
  },

  list: {
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
  },

  listItem: {
    position: "relative",
    paddingLeft: 12,
    marginBottom: 2,
    fontSize: "0.8rem",
    "&::before": {
      content: '"•"',
      position: "absolute",
      left: 0,
      color: "#6b777d"
    }
  },

  paragraph: {
    fontSize: "0.8rem",
    margin: 0
  },

  icon: {
    fontSize: "0.9rem"
  }
}));

type Props = {
  selected: TicketDifficultyLevel | null;
};

const TicketCategories: React.FC<Props> = ({ selected }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.infoBox}>
      <div className={classes.innerBoxes}>
        {selected === TicketDifficultyLevel.Easy && (
          <div className={`${classes.innerBox} ${classes.green}`}>
            <div className={classes.boxTitle}>
              <span className={classes.icon}>🟢</span> Lätta tickets
            </div>
            <div className={classes.boxDescription}>
              Ärenden som är enkla, snabba och där lösningen är tydlig:
            </div>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                Enkel tågresa (t.ex. SJ) utan byten eller specialönskemål
              </li>
              <li className={classes.listItem}>
                Förlängning av befintligt boende där vi vet att boendet är ledigt
              </li>
              <li className={classes.listItem}>
                Hotellbokning i stad med god tillgång och tydlig budget
              </li>
              <li className={classes.listItem}>
                Inga särskilda krav (djur, allergier, exakt läge etc.)
              </li>
            </ul>
          </div>
        )}

        {selected === TicketDifficultyLevel.Medium && (
          <div className={`${classes.innerBox} ${classes.yellow}`}>
            <div className={classes.boxTitle}>
              <span className={classes.icon}>🟡</span> Medel tickets
            </div>
            <div className={classes.boxDescription}>
              Ärenden som kräver viss efterforskning eller samordning, men som oftast går
              att lösa utan större hinder:
            </div>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                Resor med flera byten eller från små orter
              </li>
              <li className={classes.listItem}>
                Boende där viss dialog med hyresvärd krävs
              </li>
              <li className={classes.listItem}>
                Förlängningar där tillgänglighet behöver bekräftas
              </li>
              <li className={classes.listItem}>
                Särskilda önskemål (t.ex. gångavstånd, parkering, djurfritt)
              </li>
            </ul>
          </div>
        )}
        {selected === TicketDifficultyLevel.Hard && (
          <div className={`${classes.innerBox} ${classes.red}`}>
            <div className={classes.boxTitle}>
              <span className={classes.icon}>🔴</span> Svåra tickets
            </div>
            <div className={classes.boxDescription}>
              Ärenden som är mer komplexa och ofta tidskrävande:
            </div>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                Boende i orter med mycket låg tillgång eller högt tryck
              </li>
              <li className={classes.listItem}>
                Svår budget att förhålla sig till i relation till marknadspriser
              </li>
              <li className={classes.listItem}>Akuta bokningar med kort varsel</li>
              <li className={classes.listItem}>
                Konsulter med många specifika krav (t.ex. djur, allergier, exakt läge,
                längre perioder)
              </li>
            </ul>
          </div>
        )}

        <div className={`${classes.innerBox} ${classes.tip}`}>
          <div className={classes.boxTitle}>
            <span className={classes.icon}>💡</span> Tips
          </div>
          <p className={classes.paragraph}>
            Ju mer komplett information som finns i ticketen från start (datum, ort,
            förväntningar, bil/djur/allergier, ev. flexibilitet), desto snabbare och
            smidigare kan vi hantera ärendet – oavsett svårighetsgrad.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TicketCategories;
